import { render, staticRenderFns } from "./UserRelevancy.vue?vue&type=template&id=1785c99a&scoped=true"
import script from "./UserRelevancy.vue?vue&type=script&lang=js"
export * from "./UserRelevancy.vue?vue&type=script&lang=js"
import style0 from "./UserRelevancy.vue?vue&type=style&index=0&id=1785c99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1785c99a",
  null
  
)

export default component.exports